export const Behance = (props: SocialIconProps) => {
  const { className } = props;

  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className={className}>
      <rect
        x={1}
        y={1}
        width={62}
        height={62}
        rx={31}
        strokeWidth={2}
        className="fill-surface-secondary stroke-skin-stroke"
      />
      <path
        d="M35.813 24.197h6.234v1.512h-6.234v-1.512zm-6.247 5.984c1.378-.66 2.1-1.662 2.1-3.212 0-3.066-2.282-3.81-4.916-3.81H19.5v15.388h7.453c2.794 0 5.416-1.344 5.416-4.469 0-1.931-.913-3.36-2.803-3.897zm-6.685-4.397h3.172c1.222 0 2.319.341 2.319 1.76 0 1.306-.853 1.831-2.063 1.831h-3.428v-3.59zm3.61 10.15h-3.613v-4.237h3.684c1.488 0 2.429.622 2.429 2.197 0 1.55-1.122 2.04-2.5 2.04zm17.993-2.796c0-3.297-1.928-6.044-5.415-6.044-3.39 0-5.697 2.553-5.697 5.9 0 3.468 2.184 5.85 5.697 5.85 2.66 0 4.381-1.197 5.21-3.75H41.58c-.294.953-1.487 1.453-2.415 1.453-1.794 0-2.732-1.05-2.732-2.834h8.029c.009-.185.021-.379.021-.575zm-8.05-1.357c.097-1.465 1.075-2.381 2.538-2.381 1.537 0 2.306.903 2.44 2.381h-4.978z"
        className="fill-skin-primary"
      />
    </svg>
  );
};
